import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import * as COLOR from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE } from '../styles/typography/typography';
import { prometheanFont } from '../styles/font/font';
export var StyledProgressBarContainer = styled('div')(function (_ref) {
  var barColor = _ref['data-barcolor'];
  return {
    '&.EmbersProgressBar': {
      fontFamily: prometheanFont,
      '.progress-text': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE), {}, {
        letterSpacing: '0.02em',
        lineHeight: '20px'
      }),
      '.progress-steps': {
        display: 'flex',
        columnGap: '1px',
        '.progress-step': {
          width: '60px',
          height: '6px',
          backgroundColor: COLOR.PROMETHEAN_NEUTRAL_DARK_GREY,
          '&.active': {
            backgroundColor: barColor || COLOR.PROMETHEAN_PURPLE_GRAPE
          },
          '&:first-of-type': {
            borderRadius: '40px 0px 0px 40px'
          },
          '&:last-of-type': {
            borderRadius: '0px 40px 40px 0px'
          }
        }
      }
    }
  };
});